import { IGetSubmissionMenuLinkParams } from '@framework/frontoffice-submission';
import { BrandedPath, generatePath } from '@framework/ui';

export function getSubmissionMenuLink(input: IGetSubmissionMenuLinkParams) {
  const { type, submissionId, module, options, sectionId } = input;
  switch (type) {
    case 'module':
      return getModuleLink(submissionId, module?.id, options);
    case 'section':
      return ('#' + sectionId) as BrandedPath;
    case 'guide':
      return generatePath('/richieste/:id', { id: submissionId });
    case 'report':
      return generatePath('/richieste/:id/invia', { id: submissionId });
    case 'payment':
      return generatePath(
        options?.isSent
          ? '/richieste/:id/inviata/pagamenti'
          : '/richieste/:id/pagamenti',
        { id: submissionId },
      );
  }
}

function getModuleLink(
  submissionId: string,
  submissionModuleId: string | null | undefined,
  options: { isSent: boolean } = { isSent: false },
) {
  if (!submissionModuleId) return undefined;

  const path = options.isSent
    ? ('/richieste/:id/inviata/moduli/:moduleId' as const)
    : ('/richieste/:id/moduli/:moduleId' as const);

  return generatePath(path, {
    id: submissionId,
    moduleId: submissionModuleId,
  });
}
